import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import Loader from './Loader';
import Breadcrumb from './Breadcrumb';
import Navbar from './Navbar';

const Layout = () => {

    const { isAuthenticated } = useSelector(state => state.auth);
    const loaderCount = useSelector(state => state.loader.count);

    const loading = loaderCount > 0;

    const layoutAdmin = (
        <Fragment>
            {loading && <Loader></Loader>}
            <Navbar></Navbar>
            <Breadcrumb />
        </Fragment>
    );

    const layoutGuest = (<Fragment></Fragment>);

    if(isAuthenticated){
        return layoutAdmin;
    } else{
        return layoutGuest;
    }
}

export default Layout;